(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grille-cartes"] && !Shopify.designMode) return;
  try {
    
(function () {
  window.neowRevealReady = true;
  function init(scope) {
    var items = scope.querySelectorAll('[data-cg-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-mis-en-avant"] && !Shopify.designMode) return;
  try {
    
(function () {
  window.neowRevealReady = true;
  function init(scope) {
    var items = scope.querySelectorAll('[data-pm-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  window.neowRevealReady = true;

  /* Apparition au défilement */
  function reveal(scope) {
    var items = scope.querySelectorAll('[data-vs-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Remet une carte dans son état de départ */
  function reset(card) {
    card.classList.remove('is-playing');
    var v = card.querySelector('video');
    if (v) { v.pause(); v.controls = false; }
    var frame = card.querySelector('[data-vs-frame]');
    if (frame) { frame.innerHTML = ''; }
  }

  /* Clic sur le bouton lecture */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vs-play]');
    if (!btn) return;
    var card = btn.closest('[data-vs-card]');
    if (!card) return;

    document.querySelectorAll('[data-vs-card].is-playing').forEach(function (other) {
      if (other !== card) reset(other);
    });

    if (btn.dataset.vsMode === 'file') {
      var v = card.querySelector('video');
      if (!v) return;
      v.setAttribute('aria-label', btn.dataset.vsTitle || '');
      v.controls = true;
      card.classList.add('is-playing');
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
      v.focus();
    } else {
      var frame = card.querySelector('[data-vs-frame]');
      if (!frame || !btn.dataset.vsSrc) return;
      var ifr = document.createElement('iframe');
      ifr.src = btn.dataset.vsSrc;
      ifr.title = btn.dataset.vsTitle || '';
      ifr.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      ifr.setAttribute('allowfullscreen', '');
      frame.innerHTML = '';
      frame.appendChild(ifr);
      card.classList.add('is-playing');
      ifr.focus();
    }
  });

  /* Fin d'une vidéo importée : on réaffiche la couverture */
  document.addEventListener('ended', function (e) {
    var card = e.target.closest && e.target.closest('[data-vs-card]');
    if (!card) return;
    reset(card);
    e.target.currentTime = 0;
    var btn = card.querySelector('[data-vs-play]');
    if (btn) btn.focus();
  }, true);

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { reveal(document); }); } else { reveal(document); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
